export interface DefaultFlight {
    id: string;
    siteId: string;
    flightType: FlightType;
    uom: Uom;
    value: number;
    isDeleted?: boolean;
    tenantId?: string;
    createdDate?: string | null;
    createdBy?: string | null;
    modifiedDate?: string | null;
    modifiedBy?: string | null;
}

export enum FlightType {
    OutsideDiameter = 0,
    InsideDiameter = 1,
    MaterialThickness = 2,
}

export enum Uom {
    Mm = 0,
    Inch = 1,
}
